import fetch from 'isomorphic-fetch';
import {
  CHANNEL_FEED_REQUEST,
  CHANNEL_FEED_FAILURE,
  CHANNEL_FEED_SUCCESS,
  CHANNEL_FEED
} from "../constants";
import { checkHttpStatus, parseJSON } from '../utils';

export function channelFeedSuccess(feed) {
  return {
    type: CHANNEL_FEED_SUCCESS,
    payload: {
      feed,
    },
  };
}

export function channelFeedFailure(error, message) {
  return {
    type: CHANNEL_FEED_FAILURE,
    payload: {
      status: error,
      statusText: message,
    },
  };
}

export function channelFeedRequest() {
  return {
    type: CHANNEL_FEED_REQUEST,
  };
}

export function fetchChannels() {
  return (dispatch, getState) => {
    dispatch(channelFeedRequest());
    return fetch(`${SERVER_URL}/channels`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(channelFeedSuccess(response.data));
      })
      .catch((err) => {
        console.error(err);
        return dispatch(channelFeedFailure());
      });
  };
}
